import styled from "@emotion/styled";

const LayoutWidthContainer = styled.div`
  width: 100%;
  padding: 0 16px 0 16px;
  justify-self: center;

  max-width: calc(1144px + 2 * 16px);
`;

export default LayoutWidthContainer;
